import { httpGet } from "@/api/connection";
import { GetArtifactsFn, GetArtifactsParams } from "./artifacts.types";

const queryKey = ["artifacts", "list"];

const artifactsQueryKeys = {
  all: ["artifacts", "list"],
  list: (query?: GetArtifactsParams) => ["artifacts", "list", query],
  infiniteList: (query?: GetArtifactsParams) => [
    "artifacts",
    "infinite-list",
    query,
  ],
};

const get: GetArtifactsFn = async (values = {}) => {
  return httpGet("/analysis/artifacts", values);
};

export const ArtifactsAPI = {
  get,
  queryKey,
  queryKeys: artifactsQueryKeys,
};
